// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"891b249c","453":"6cac04e2","455":"d1dcea52"}[chunkId] + ".chunk.js";
};